export default __webpack_public_path__ + "static/media/205.36330191.gif";